module.exports = __webpack_public_path__ + "images/bc5b2a2a8711603255e7e8f383164f86.png";